import Loadable from "app/components/Loadable";
import { lazy } from "react";

const CongresoCNAF = Loadable(lazy(() => import("./CongresoCNAF")));

const CongresoCNAFRoutes = [{ path: "/congreso_cnaf2024", element: <CongresoCNAF /> }];

export default CongresoCNAFRoutes;
